import { StyledEngineProvider } from '@mui/material/styles'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { RouterProvider, type RouterProviderProps } from 'react-router-dom'

import { browserTokenStorage, initializeSession } from '../../features/identity'
import { BrowserTelemetry, TelemetryProvider } from '../../platform/telemetry'
import { AppThemeProvider } from '../../shared/theme'
import { appConfig } from '../../platform/config/app-config'
import { appStore } from '../store/store'

const appTelemetry = new BrowserTelemetry({
  endpoint: appConfig.telemetryEnabled ? appConfig.telemetryEndpoint : null,
})

type AppProvidersProps = {
  router: RouterProviderProps['router']
}

export function AppProviders({ router }: AppProvidersProps) {
  useEffect(() => {
    initializeSession(appStore.dispatch, browserTokenStorage)
  }, [])

  return (
    <Provider store={appStore}>
      <TelemetryProvider telemetry={appTelemetry}>
        <StyledEngineProvider enableCssLayer>
          <AppThemeProvider>
            <RouterProvider router={router} />
          </AppThemeProvider>
        </StyledEngineProvider>
      </TelemetryProvider>
    </Provider>
  )
}
